import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Box, Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import DashboardLogo from 'ui-component/DashboardLogo';
import usePublicBranding from 'hooks/usePublicBranding';
import { changeLogoUrlToAWS } from 'utils/image';

// ==============================|| MAIN LOGO ||============================== //

const getClientLogoUrl = (branding) => {
    const logoUrl = branding?.logo?.absolute150 || branding?.logo?.absolute;

    if (typeof logoUrl !== 'string' || !logoUrl.trim()) return '';

    return changeLogoUrlToAWS(logoUrl.trim()) || '';
};

const LogoSection = () => {
    const branding = usePublicBranding();
    const clientLogoUrl = getClientLogoUrl(branding);
    const [failedLogoUrl, setFailedLogoUrl] = useState('');
    const showClientLogo = Boolean(clientLogoUrl) && failedLogoUrl !== clientLogoUrl;

    return (
        <Link
            component={RouterLink}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: 76, textDecoration: 'none', pr: 1 }}
            to={DASHBOARD_PATH}
            aria-label="Go to Candidate Portal home"
        >
            {showClientLogo ? (
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'common.white',
                        borderRadius: '10px',
                        overflow: 'hidden'
                    }}
                >
                    <Box
                        component="img"
                        src={clientLogoUrl}
                        draggable={false}
                        alt={branding?.tradingName ? `${branding.tradingName} logo` : 'Client logo'}
                        onError={() => setFailedLogoUrl(clientLogoUrl)}
                        sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                </Box>
            ) : (
                <DashboardLogo />
            )}
        </Link>
    );
};

export default LogoSection;
